import { useMutation } from '@tanstack/react-query';

import type { UpdateParticipationArgs } from '../../../Domain/Employees/Services/EmployeeService';
import { employeeService } from '../../../Domain/Employees/Services/EmployeeService';

const mutationFn = (data: UpdateParticipationArgs) => {
  return employeeService.updateParticipation(data);
};

export const useEmployeeUpdateParticipationMutation = () => {
  return useMutation<unknown, unknown, UpdateParticipationArgs>(mutationFn);
};
